var throttle   = require('./functions').throttle;
var debounce   = require('./functions').debounce;
var showChannelNav = require('./showChannelNav');
var showAllChannelNav = require('./showAllChannelNav');
var displayDynamicContent = require('./displayDynamicContent');

var toggleChannelNav = function(){
  var body;
  var buttons;
  var nav;
  var orinalNavClasses;
  var dropdownNav;
  var state = {}

  var _init = function(){
    body = document.body;
    nav = document.getElementById('main-nav');
    orinalNavClasses = nav.classList;
    buttons = document.getElementsByClassName('m-main-nav__item');
    
    state = {
      type: null,
      slug: null,
      oldSlug: null
    }

    _addEventListeners();
  }

  //add eventlisteners too the buttons
  var _addEventListeners = function(){
    [].map.call(buttons, function(button){

      if (!button.classList.contains('m-main-nav__item--logo') && !button.classList.contains('m-main-nav__item--channel-logo')) {
        button.addEventListener('mouseenter', _showDropdown);
      }
    });
  };

  //show the navigation dropdown
  var _showDropdown = function(e){
    //if state contains slug call function showChannel nav
    //function can be found in showChannelNav.js
    //we don't want to display any dropdown when the logo is hovered
    if (state.slug === 'homepage') {return;}

    window.addEventListener('mousemove', _hideDropDown);

    //returns button type of current button
    _checkButtonType(e.target);
    
    if (state.type === 'slug') {
      // showChannelNav.init(state.slug);
      // displayDynamicContent.get(state.slug);
      body.classList.remove('is-channel-dropdown-open');
      _addSlugClass();
    }else{
    //if state does not contain a slug it shows the dropdown menu of all channels 
      _removeSlugClass();
      showAllChannelNav.init();
      body.classList.add('is-channel-dropdown-open');
    }
  }
  
  //returns object state wether we need to make an ajax call or just show the all channels page
  var _checkButtonType = function(button){
    var slug = button.dataset.slug;
    state.oldSlug = state.slug;

    if (slug === undefined) {
      state.type = 'all-channels';
    }else{
      state.type = 'slug';
      state.slug = slug;
    }
    
    return state;
  }

  //checks if dropdown is hovered or not
  var _hideDropDown = function(e){
    var el = e.target;

    //if the parent contains m-main-content or m-main-header it hides the dropdown
    if (el.classList.contains('m-main-content') || el.classList.contains('m-main-header') || el.classList.contains('tailwind') || el.classList.contains('m-main-nav-dropdown__emercetv')) {
      _removeSlugClass();
      body.classList.remove('is-channel-dropdown-open');
      window.removeEventListener('mousemove', _hideDropDown);  
    }
  }

  var _addSlugClass = function(){
    nav.classList.remove(state.oldSlug);
    nav.classList.add(state.slug);
  };

  var _removeSlugClass = function(){
    nav.classList.remove(state.slug);
  };

  return {
    init: _init
  }
}();

if (document.getElementById('main-nav')) {
  toggleChannelNav.init();
}